<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-0">Update Contact Number</p>
        <v-form v-model="isNumberValid">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="contact"
                label="Contact Number"
                :rules="phMobileRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="pt-6">
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            :disabled="!isNumberValid"
            @click="finish"
            >Finish</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      tenantId: -1,
      contact: '',
      dialog: false,
      isNumberValid: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ]
    }
  },
  methods: {
    open(params) {
      this.tenantId = params.tenantId
      this.contact = params.contact
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        await this.$store.dispatch('units/updateBedContactAction', {
          contact: this.contact,
          tenantId: this.tenantId
        })
        this.dialog = false
        this.resolve(this.contact)
        this.$router.go()
      } catch (err) {
        this.$root
          .$confirm({
            title: 'Update Contact Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
